import { Component, inject } from '@angular/core';
import { GlobalActions, GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { NxLayoutComponent, NxRowComponent, NxColComponent } from '@allianz/ng-aquila/grid';
import { NgOptimizedImage } from '@angular/common';
import { NxHeadlineComponent } from '@allianz/ng-aquila/headline';
import { NxCopytextComponent } from '@allianz/ng-aquila/copytext';
import { NxButtonComponent } from '@allianz/ng-aquila/button';
import { LinkComponent } from '@ps20-frontend/gui-components';
import { TextPipe, HtmlPipe } from '@ps20-frontend/text-service';

@Component({
  selector: 'ps20-shop-forwarded-to-underwriter-page',
  templateUrl: './forwarded-to-underwriter-page.component.html',
  styleUrl: './forwarded-to-underwriter-page.component.scss',
  imports: [
    NxLayoutComponent,
    NxRowComponent,
    NxColComponent,
    LinkComponent,
    NgOptimizedImage,
    NxHeadlineComponent,
    NxCopytextComponent,
    NxButtonComponent,
    TextPipe,
    HtmlPipe,
  ],
})
export class ForwardedToUnderwriterPageComponent {
  private readonly globalEventDispatcher = inject<GlobalEventDispatcher>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- raw string DI token (globalEventDispatcherRef), not a typed InjectionToken
    'globalEventDispatcherRef' as any,
  );
  private readonly globalActions = inject(GlobalActions);

  constructor() {}

  backToShop(): void {
    this.globalEventDispatcher.dispatch(this.globalActions.closeForwardedToUnderwriterPage());
  }
}
